module.exports = __webpack_public_path__ + "static/img/fire_1.f7c8bf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fire_1.png
// module id = 4jJq
// module chunks = 1